import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import NewsInfo from 'shared/components/NewsInfo/NewsInfo';
import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import AnotherCars from 'desktop/components/AnotherCars/AnotherCars';
import s from './NewsPage.css';

class NewsPage extends React.Component {
  static propTypes = {
    post: PropTypes.shape().isRequired,
    relatedAdverts: PropTypes.arrayOf(PropTypes.shape()),
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        link: PropTypes.string,
        title: PropTypes.string,
      }),
    ).isRequired,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    relatedAdverts: [],
    tag: null,
  };

  render() {
    const { post, relatedAdverts, intl, breadcrumbs } = this.props;
    const { locale } = intl;
    const localizedTitle =
      locale === 'ru' ? post.title || post.title_uk : post.title_uk || post.title;

    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <Breadcrumbs current={localizedTitle} links={breadcrumbs} />
              <NewsInfo post={post} />
              {relatedAdverts &&
                relatedAdverts.length > 0 &&
                <AnotherCars
                  cars={relatedAdverts}
                  title={intl.formatMessage({ id: 'Объявления' })}
                />}
            </div>

            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(NewsPage));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/news-page/NewsPage.js